/* eslint-disable no-use-before-define */
import PropTypes from 'prop-types';

import React from 'react';
import { connect as connectR } from 'react-redux';
import { Outlet } from 'react-router-dom';
import TranslationUtil from '../util/translation';
import I18nContext from '../i18n/I18nContext';

class ComponentContainer extends React.Component {
    static propTypes = {
        children: PropTypes.object,
        settingsLanguage: PropTypes.string,
    };

    state = {
        i18nValue: {
            currentLanguage: TranslationUtil.getCurrentLanguage(
                this.props.settingsLanguage
            ),
            i18nTheme: {
                subscribe: (handler) => this.subscribeHandler(handler),
                get: () => this.getLanguage(),
            },
        },
    };

    componentDidUpdate(prevProps) {
        if (prevProps.settingsLanguage !== this.props.settingsLanguage) {
            this.setState({
                i18nValue: {
                    ...this.state.i18nValue,
                    currentLanguage: this.props.settingsLanguage,
                },
            });
        }
        this.listeners.notify();
    }

    getLanguage() {
        return TranslationUtil.getCurrentLanguage(this.props.settingsLanguage);
    }

    listeners = createListenerCollection();

    subscribeHandler = (handler) => {
        return this.listeners.subscribe(handler);
    };

    render() {
        return (
            <I18nContext.Provider value={this.state.i18nValue}>
                <Outlet />
            </I18nContext.Provider>
        );
    }
}

export default connectR((store) => ({
    settingsLanguage: store.genericSettings.language,
}))(ComponentContainer);

const CLEARED = null;

function createListenerCollection() {
    // the current/next pattern is copied from redux's createStore code.
    let current = [];
    let next = [];

    return {
        clear() {
            next = CLEARED;
            current = CLEARED;
        },

        notify() {
            current = next;
            const listeners = current;
            for (let i = 0; i < listeners.length; i++) {
                listeners[i]();
            }
        },

        get() {
            return next;
        },

        subscribe(listener) {
            let isSubscribed = true;
            if (next === current) next = current.slice();
            next.push(listener);

            return function unsubscribe() {
                if (!isSubscribed || current === CLEARED) return;
                isSubscribed = false;

                if (next === current) next = current.slice();
                next.splice(next.indexOf(listener), 1);
            };
        },
    };
}
